import { flow } from 'mobx-state-tree';
import { getStores } from '../..';

export const fetchSearchResults = flow(function* (self, searchtext, position) {
  try {
    const { config } = getStores(self, 'config');
    self.loading = true;

    if (config.gysService.useMock) return;

    const distance = config.mapBox.searchRadius[self.searchRadius];
    const isDistanceInfinite = self.searchRadius === 'infinite';

    const queryParams =
      (!isDistanceInfinite
        ? // if distance is limited
          `lat=${position?.latitude || 0}&lon=${
            position?.longitude || 0
          }&distance=${distance}&`
        : '') +
      // the part that is always send
      `query=${searchtext}&lng=${config.gysService.language}`;

    const response = yield fetch(
      `${config.gysService.url}/get-your-spot/textsearch?${queryParams}`,
      {
        crossDomain: true,
        credentials: 'include',
      },
    );

    const responseJson = yield response.json();

    if (!Array.isArray(responseJson)) {
      self.searchResults = [];
    } else {
      self.searchResults = responseJson;
    }
  } catch (error) {
    console.error(error);
  } finally {
    self.loading = false;
  }
});
